//config details to be updated.

const rootConfigProd = {
    apiKey: "AIzaSyBYBeJfvLszbR-YiDwsNlA4upa-1oNk9Cg",
    authDomain: "kookoo-tv.firebaseapp.com",
    databaseURL: "https://kookoo-tv-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kookoo-tv",
    storageBucket: "kookoo-tv.appspot.com",
    messagingSenderId: "507246863308",
    appId: "1:507246863308:web:0feec73f3048c1d2d17369",
    measurementId: "G-Q4YWSVBHL2"
}

const rootConfigPreprod = {
    apiKey: "AIzaSyAzzyp4sCyfmG9srlnZGJDKEzs6hwi0Ei0",
    authDomain: "kookootv-staging.firebaseapp.com",
    databaseURL: "https://kookootv-staging-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kookootv-staging",
    storageBucket: "kookootv-staging.appspot.com",
    messagingSenderId: "198263746174",
    appId: "1:198263746174:web:33cfc5df162ce0eda1f22f",
    measurementId: "G-YXEEZN15G8"
}


const secondaryConfigProd = {
    apiKey: "AIzaSyBYBeJfvLszbR-YiDwsNlA4upa-1oNk9Cg",
    authDomain: "kookoo-tv.firebaseapp.com",
    databaseURL: "https://kookoo-tv-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kookoo-tv",
    storageBucket: "kookoo-tv.appspot.com",
    messagingSenderId: "507246863308",
    appId: "1:507246863308:web:0feec73f3048c1d2d17369",
    measurementId: "G-Q4YWSVBHL2"
}

const secondaryConfigPreprod = {
    apiKey: "AIzaSyAzzyp4sCyfmG9srlnZGJDKEzs6hwi0Ei0",
    authDomain: "kookootv-staging.firebaseapp.com",
    databaseURL: "https://kookootv-staging-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "kookootv-staging",
    storageBucket: "kookootv-staging.appspot.com",
    messagingSenderId: "198263746174",
    appId: "1:198263746174:web:33cfc5df162ce0eda1f22f",
    measurementId: "G-YXEEZN15G8"
}

const development= process.env.REACT_APP_ENV === 'development';

const firebaseConfigurations={  
    primary: development ? rootConfigPreprod : rootConfigProd,
    secondary: development ? secondaryConfigPreprod: secondaryConfigProd
}

export { firebaseConfigurations };